<app-multiple-select-filter
        [parentFormGroup]="parentFormGroup"
        noEntriesFoundLabel="Aucun document"
        [parentFormControlName]="parentFormControlName"
        [elements]="elements"
        [filterElementProcessor]="filter">
  <ng-template template-content let-element='element'>
      <i-tabler name="pin" class="icon-16" *ngIf="element.sticky"></i-tabler> {{element.label}} <span style="font-size: 0.8em">({{element.format.label}})
        - créé le <app-datetime-label [date]="element.creationDate"></app-datetime-label>

  </span>
  </ng-template>
</app-multiple-select-filter>
